import { useTranslation } from '@chr/online-shared-ui-localizations';
import { Icon, IconButton, Paper, PaperProps } from '@mui/material';

export type MapControlsPanelProps = PaperProps & {
  onClose(): void;
};

export const MapControlsPanel = ({ children, onClose, ...props }: MapControlsPanelProps) => {
  const translate = useTranslation();
  return (
    <Paper
      variant="outlined"
      {...props}
      sx={{
        backgroundColor: 'background.paper',
        borderColor: 'background.paper',
        color: 'text.primary',
        boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12)',
        marginBottom: 1,
        padding: 2,
        width: 240,
        position: 'absolute',
        right: 0,
        bottom: '40px',
        ...props.sx
      }}
    >
      <IconButton
        title={translate('Collapse')}
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 26,
          top: 12,
          width: 32,
          height: 32,
          color: 'text.primary',
          ':hover': {
            color: 'text.primary',
            backgroundColor: 'map.panel.button.hover'
          },
        }}
      >
        <Icon sx={{ fontSize: 24 }}>close</Icon>
      </IconButton>
      {children}
    </Paper>
  );
};
